<script>
export default {
  props: {
    title: String,
    content: {
      type: [String, Array],
      default: '系統忙碌中!'
    },
    btnConfirmText: {
      type: String,
      default: '確定'
    },
    errorHandler: {
      type: Function
    },
    closeHandler: {
      type: Function
    },
    /**
     * content would be with order
     */
    listType: {
      type: String,
      default: 'ul'
    }
  },
  data () {
    return {
      show: false
    }
  },

  computed: {
    contentItem () {
      const { content, listType } = this
      const isArray = Array.isArray(content)
      let result = content
      if (isArray) {
        let list = ''
        content.forEach(el => {
          list += `<li>${el}</li>`
        })
        result = `<${listType}>${list}</${listType}>`
      }
      return result
    }
  },

  methods: {
    afterClose () {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-btn
  height $height!important
  min-width 120px!important
ul
  li
    list-style-type none
</style>
